module.exports = __webpack_public_path__ + "img/logo-kibana.4b3cfc99.svg";